<!--
 * CvColumn support breakpoints property: max, xlg ,lg, md, sm
 * @see https://www.carbondesignsystem.com/guidelines/layout#breakpoints
 *
 * usage
 * ..
 * (1) span   : <cv-column `breakpoint`="`span`"></cv-column>
 * (2) offset : <cv-column `breakpoint`="`offset`-`span`"></cv-column> 
 *
 * @example <cv-column lg="12-4" md="4-4" sm="4">children</cv-column> 
 * ..
 * <div class="bx--col-sm-4 bx--offset-md-4 bx--col-md-4  bx--offset-lg-12 bx--col-lg-4 ">
 *   <div class="col--wrapper">children</div>
 * </div>
 *
-->
<template>
  <div :class="cssClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
import columnMixin from "@/plugins/carbon-custom/mixin/column.mixin";

defineOptions({
  mixins: [columnMixin],
});
</script>
